export const auditStatusConfigForAuditMaster = {
    newAudits: "New",
    pendingAtAuditor: "Pending At Auditor",
    auditedByAuditor: "Audited",
    auditedByAuditee: "Pending At Auditee",
    closePending: "Submitted By Auditee",
    closed: "Closed"
}

export const thirdPartyStatusConfigData = {
    draftAudits: "Draft",
    reviewPending: "Review Pending",
    completed: "Completed",
}

export const thirdPartyRemarkConfigData = {
    invalidInfo: "Invalid Info",
    missingDetails: "Missing Details",
    insufficientDocuments: "Insufficient Documents",
    invalidDocuments: "Invalid Documents",
    success: "Success",
    notAvailable: "Not Available",
}